<template>
	<v-menu :close-on-content-click="false" min-width="290px" offset-y transition="scale-transition" v-model="menu">
		<template #activator="{ on }">
			<v-text-field
				dense
				:clearable="clearable"
				:error="errorBorder"
				:error-messages="error"
				:hide-details="hideDetails"
				:label="dateLabel"
				outlined
				v-model="valueFormatted"
				v-on="on"
				@blur="textFieldBlur()"
				@focus="textFieldFocus()"
				ref="dateField"
				:readonly="readonly"
				:disabled="disabled"
			></v-text-field>
		</template>
		<v-date-picker
			v-if="!readonly && !disabled"
			:first-day-of-week="1"
			:locale="'hr'"
			:readonly="readonly"
			:disabled="disabled"
			@input="menu = false"
			v-model="selectedValue"
		></v-date-picker>
	</v-menu>
</template>

<script>
export default {
	name: 'DatePicker',
	props: {
		readonly: Boolean,
		disabled: Boolean,
		value: String,
		dateLabel: String,
		clearable: {
			type: Boolean,
			default: false,
		},
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			menu: false,
			valueFormatted: null,
			selectedValue: this.$props.value,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != null) {
					if (this.selectedValue != null) {
						if (this.selectedValue.value != newVal) {
							this.setValue(newVal);
						}
					} else {
						this.setValue(newVal);
					}
				} else {
					this.selectedValue = null;
					this.callChange();
				}
			}
		},
		selectedValue: function (val) {
			this.valueFormatted = this.formatDate(this.selectedValue);
			if (val != null) {
				if (val != this.$props.value) {
					this.$nextTick(() => {
						this.$emit('input', val);
					});
				}
			} else {
				this.$nextTick(() => {
					this.$emit('input', null);
				});
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		textFieldBlur() {
			this.selectedValue = this.parseDate(this.valueFormatted);
		},
		textFieldFocus() {
			this.$refs.dateField.$el.querySelector('input').select();
		},
		parseDate(date) {
			if (!date) return null;
			let moment = require('moment');
			date = moment(date, 'D.M.YYYY.');
			if (date.isValid()) {
				return date.format('YYYY-MM-DD');
			}
			return null;
		},
		formatDate(date) {
			if (!date) return null;
			const [year, month, day] = date.split('-');
			return `${parseInt(day)}.${parseInt(month)}.${year}.`;
		},
		setValue(newVal) {
			this.selectedValue = newVal;
			this.valueFormatted = this.formatDate(this.selectedValue);
			this.callChange();
		},
	},
	mounted() {
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped></style>
